var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSign = function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.31a.6.6 0 0 1 .599.6v2.127h3.946a.6.6 0 1 1 0 1.2H12.6V11.4h1.674a3.782 3.782 0 0 1 0 7.564h-1.674v2.127a.6.6 0 1 1-1.2 0v-2.127H6.546a.6.6 0 0 1 0-1.2H11.4V12.6H9.727a3.783 3.783 0 0 1-2.674-6.456 3.78 3.78 0 0 1 2.674-1.108H11.4V2.91a.6.6 0 0 1 .6-.6m.599 15.454h1.674a2.582 2.582 0 0 0 0-5.163h-1.674zM9.727 6.236a2.582 2.582 0 0 0 0 5.164H11.4V6.236z"
  })));
};
export default SvgDollarSign;